import styled, { keyframes } from "styled-components";

import COLORS from "../common/Colors";

const rotate = keyframes`
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
`;

const Spinner = styled.div`
	animation: ${rotate} 1s linear infinite;
	background: ${({ color = COLORS.AMARNATH }) => color};
	border-radius: 50%;
	width: ${({ size = "40px" }) => size};
	height: ${({ size = "40px" }) => size};
	position: relative;

	&::before {
		border-radius: 50%;
		background: linear-gradient(0deg, hsla(0, 0%, 100%, 1) 50%, hsla(0, 0%, 100%, 0.9) 100%) 0% 0%,
			linear-gradient(90deg, hsla(0, 0%, 100%, 0.9) 0%, hsla(0, 0%, 100%, 0.6) 100%) 100% 0%,
			linear-gradient(180deg, hsla(0, 0%, 100%, 0.6) 0%, hsla(0, 0%, 100%, 0.3) 100%) 100% 100%,
			linear-gradient(360deg, hsla(0, 0%, 100%, 0.3) 0%, hsla(0, 0%, 100%, 0) 100%) 0% 100%;
		background-repeat: no-repeat;
		background-size: 50% 50%;
		top: -1px;
		bottom: -1px;
		left: -1px;
		right: -1px;
		content: "";
		position: absolute;
	}

	&::after {
		border-radius: 50%;
		background: ${COLORS.WHITE};
		top: ${({ thickness = "10%" }) => thickness};
		bottom: ${({ thickness = "10%" }) => thickness};
		left: ${({ thickness = "10%" }) => thickness};
		right: ${({ thickness = "10%" }) => thickness};
		content: "";
		position: absolute;
	}
`;

export default Spinner;
